
export const json = x => document.querySelector(x) && JSON.parse(document.querySelector(x).textContent) || null